// The server brands every string it serves; this does the same for the text the client carries itself, which
// is shown for any key the server's pack lacks and before that pack loads. Only the capitalised name is
// replaced, so links such as https://telegram.org/tos keep working.
const BRAND_PATTERN = /Telegram(?![a-z])/g;
const BRAND_NAME = 'Jaryan';

export function brandText(text: string) {
  return text.replace(BRAND_PATTERN, BRAND_NAME);
}

function brandValue<T>(value: T): T {
  if (typeof value === 'string') {
    return brandText(value) as T;
  }

  if (value && typeof value === 'object') {
    return Object.fromEntries(Object.entries(value).map(([form, text]) => (
      [form, typeof text === 'string' ? brandText(text) : text]
    ))) as T;
  }

  return value;
}

export function brandStrings<T extends Record<string, unknown>>(strings: T): T {
  return Object.fromEntries(Object.entries(strings).map(([key, value]) => [key, brandValue(value)])) as T;
}
